import React from "react";
import { createRoot } from "react-dom/client";
import { SettingsApp } from "./SettingsApp";

document.addEventListener("DOMContentLoaded", function () {
	const container = document.getElementById("image-hub-settings-root");
	if (container) {
		const root = createRoot(container);
		root.render(
			<React.StrictMode>
				<SettingsApp />
			</React.StrictMode>,
		);
	}
});
